{
  "eyebrow": "Tarif bestätigen",
  "title": "Prüfen & konfigurieren.",
  "sub": "Abrechnungszyklus oder Tarif können Sie jederzeit über Ihr Admin-Dashboard ändern.",
  "yourPlan": "Ihr Tarif",
  "changePlan": "Tarif ändern",
  "billing": "Abrechnungszyklus",
  "billingMonthLabel": "Monatlich zahlen",
  "billingMonthDesc": "Flexibel. Jederzeit kündbar.",
  "billingYearLabel": "Jährlich zahlen",
  "billingYearDesc": "15% Rabatt. Einmal jährlich abgerechnet.",
  "addons": "Zusatzmodule",
  "addon": {
    "ssec": "Sozialversicherung (Check-in/out@work)",
    "ssecDesc": "Nur Belgien — automatische Dimona-Meldung.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Live-GPS für Firmenfahrzeuge. +4 €/Fahrzeug/Monat.",
    "vehicles": "Fahrzeuge"
  },
  "employees": {
    "title": "Wie viele Mitarbeitende?",
    "active": "Benutzer",
    "popular": "Die meisten Teams wählen {{n}}"
  },
  "estimate": "Geschätzte monatliche Kosten",
  "estimateNote": "Zzgl. MwSt. Sie zahlen für die hier eingestellte Anzahl an Benutzern und können sie später ändern.",
  "estimateUnavailable": "Preiskatalog nicht verfügbar. Erneut versuchen, um die aktuellen Preise zu laden."
}
